import axios from 'axios'
import Swal from 'sweetalert2'

export default class AjaxForm {
  constructor (node) {
    this.node = node
    this.init()
  }

  init () {
    this.form = this.node.querySelector('form')
    this.form.addEventListener('submit', e => this.onSubmit(e))
    this.errorList = this.node.querySelector('[form-errors]')
  }

  onSubmit (e) {
    e.preventDefault()
    this.clearErrors()
    this.makeRequest()
  }

  makeRequest () {
    this.disableInput()

    axios.request(this.buildRequestConfig())
      .then(response => this.handleSuccessResponse(response))
      .catch(error => this.handleErrorResponse(error.response))
      .finally(() => {
        this.enableInput()
      })
  }

  buildRequestConfig () {
    const data = new FormData(this.form)

    return {
      url: this.form.getAttribute('action'),
      method: this.form.getAttribute('method'),
      data: data,
      headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'X-Requested-With': 'XMLHttpRequest',
      }
    }
  }

  handleSuccessResponse (response) {
    const successMessage = this.node.querySelector('[data-success-message]')
    Swal.fire({
      type: 'success',
      title: successMessage ? successMessage.innerHTML : 'Done',
    })

    this.clearErrors()
    this.form.reset()
  }

  handleErrorResponse (response) {
    if (!response.data.errors) return false

    response.data.errors.forEach(error => {
      this.errorList.append(this.getErrorEl(error))
    })

    this.errorList.style.display = 'block'
  }

  getErrorEl (message) {
    const errorItem = document.createElement('li')
    errorItem.innerHTML = message

    return errorItem
  }

  clearErrors () {
    this.errorList.style.display = 'none'

    while (this.errorList.firstChild) {
      this.errorList.removeChild(this.errorList.firstChild)
    }
  }

  disableInput () {
    this.form.classList.add('disabled')
  }

  enableInput () {
    this.form.classList.remove('disabled')
  }
}
